export enum ImageKinds {
  Image = 1,
  ClaioImage = 2,
  ClaioMovie = 3,
  ClaioSchema = 4,
  ClaioSchemaEdit = 5
}
